module.exports = __webpack_public_path__ + "media/luxury-2026/photo-staging-interior-960-b78067d0.jpg";